import addPerfMetricToPageTimings from 'mini-performance/lib/utils/addPerfMetricToPageTimings';
import { DatapointVariant } from 'owa-analytics-actions';
import { PerformanceDatapoint } from 'owa-analytics';

/**
 * Log the performance measure
 * @param perfMeasure The PerformanceEntry to log
 * @param name Datapoint name to log. If not specified, uses the performance measure name
 * @param logOnce If true, logs only the first time the datapoint is fired
 * @param addToPageTimings If true, adds the perf metrics to global _pageTimings object
 * @param markAsCore If true, marks the datapoint as core event so that sampling is turned off for the event
 */
export function logPerfMeasure(
    perfMeasure: PerformanceEntry,
    name?: string,
    logOnce?: boolean,
    addToPageTimings?: boolean,
    markAsCore?: boolean,
    customPayload?: any
) {
    if (perfMeasure) {
        const { startTime, duration } = perfMeasure;
        const endTime = Math.round(startTime + duration);
        const measureName = name || perfMeasure.name;
        const options = { isCore: !!markAsCore };
        const perfdp = new PerformanceDatapoint(
            measureName,
            logOnce ? { ...options, variant: DatapointVariant.WarmOnly } : options
        );
        perfdp.addCustomData({ duration, ...customPayload });
        perfdp.end(endTime);
        !!addToPageTimings && addPerfMetricToPageTimings(measureName, endTime);
    }
}
